<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view ref="routerView" v-if="!$route.meta.keepAlive"></router-view>
    <AppFooter :menus="appFooterData" v-show="showAppFooter"></AppFooter>
    <Barrage v-if="show_barrage"></Barrage>
    <PlayControl v-if="!miniHide && showPlaycontrol"></PlayControl>
    <NotVipToast></NotVipToast>
    <fansModal v-if="fansModalVipShow"></fansModal>
    <Skeleton />
    <VipPackagesToast v-if="showVipPackagesToast"/>
    <OrderSuccess @refresh="handleRefresh"/>
    <Agreement v-if="isAgreeShow" @closeAgree="closeAgree"/>
    <SCodeBox v-if="isShowScode" />
    <GiftBox v-if="isShowGiftBox" />
    <HomeToast v-if="computedShowToast"></HomeToast>
    <PhotoToast v-if="showPhotoToast"></PhotoToast>
    <PayToast v-if="isShowPayToast"></PayToast>
    <VoiceSearchDialog v-if="isShowVoiceSearch" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AppFooter from '@/components/app/footer/footer';
import Barrage from '@/components/app/barrage';
import PlayControl from '@/components/app/play_control';
import NotVipToast from '@/components/app/adsense/not_vip_toast';
import fansModal from '@/components/app/fans_modal';
import Skeleton from '@/components/app/skeleton/index';
import VipPackagesToast from '@/components/app/vip/packagesToast';
import OrderSuccess from '@/components/app/orderSuccess/index'
import Agreement from '@/components/app/agreement/agreement.vue';
import SCodeBox from '@/components/app/scode_box/index'
import GiftBox from '@/components/app/gift/gift_box'
import HomeToast from '@/components/app/adsense/home_toast.vue';
import PhotoToast from '@/components/app/photo/photo_toast.vue';
import get from 'lodash/get';
import weixin from './libs/app/weixin';
import createSquare from '@/libs/app/square';
import order from './views/order/utils/order'
import axiosAgent from './views/order/utils/request';
import { chttp } from '@/libs/interfaces';
import cookie from '@/libs/utils/cookie';
// import { FOOTRT_ICON_THEME } from '@/libs/utils/consts'
import PayToast from '@/components/app/pay_toast/index'
import VoiceSearchDialog from '@/components/app/voice_search_dialog/index'

/*
 * 组件级说明：
 * App 根组件负责全局页面结构与底部导航栏菜单的构建。
 * 为满足“首页使用 dark 主题、其他页面使用 light 主题，底部 icon 随主题动态切换”的需求：
 * 1) 主题在路由 afterEach 中根据路由名设为 dark/light；
 * 2) 组件通过 $theme 重新计算 FOOTRT_ICON_THEME，刷新底部导航图标；
 * 3) 监听 $theme 的变化，在路由切换导致主题变更时自动调用 initAppFooterData() 更新图标。
 */
export default {
  data() {
    return {
      appFooterData: [],
      square: null,
      isShowMenu: false,
      isSouyu: false,
      isLitong: false,
    };
  },
  async created() {
    // 设置主题
    // this.$store.commit('SET_THEME', 'blue');
    if (process.env.NODE_ENV === 'development') {
      weixin.getOpenID('thunder/home', { type: this.$store.state.vod_type });
    }
    this.$store.dispatch('getHomeConfig', {
      callback: async () => {
        const is24hours = Number(cookie.getCookie('is24hours')) || 0
        if ((['role2', 'role5', 'role4'].includes(this.$store.state.role)) && !is24hours) {
          cookie.setCookie(1, 1, 'is24hours');
        }
        this.$store.dispatch('getAutoOrderSong', {
          router: this.$router,
        });
        if (location.href.includes('/thunder/maiba_list')) {
          const actionTxt = this.is_bind ? '已绑定' : '未绑定';
          const actionType = location.href.includes('common') ? '普通' : '活动';
          this.$sendLog({
            event_type: 'show',
            event_name: `${actionType}-麦霸歌单页-${actionTxt}`,
            event_data: {
              action: '曝光量',
            },
          });
        }
        if (this.unionid) {
          createSquare(this.unionid, this.openid, (msg) => {
            this.$store.commit('SET_SOCKETMSG', msg);
          });
        }
        await this.getOrderSystem()
        if (!this.isSouyu) {
          const litong = await this.refreshLiTongAccessToken()
          if (litong) {
            // await this.getliTongvodStoreInfo()
          }
        }
        this.initAppFooterData();
        // 雷客环境Linux下 需要请求下盒子是否过期
        if (this.isLeikeLinux) {
            this.$store.dispatch('getLeikeInfo')
        }
        // 用户进入 h5 自动发送特效
        // await this.$store.dispatch('sendSpecialEffict');
      }, // 获取常唱歌曲
    });
    // 获取用户信息
    this.$store.dispatch('getUserInfo');
    this.$store.dispatch('getADInfo');
    // TODO 初始化底导航菜单数据先放在这，后面再考虑个好地方
    this.initAppFooterData();
    await this.$store.dispatch('getRankAttach');
  },
  beforeDestroy() {
    if (this.routeTrack) {
      this.routeTrack.unload()
    }
  },
  methods: {
    handleRefresh() {
      if (this.$route.path != '/thunder/ordered') return
      this.$refs.routerView.handleRefresh()
    },
    initAppFooterData() {
      const appFooterData = [
        {
          name: 'home',
          text: '点歌',
          route: '/thunder/home',
          isDot: false,
          hasFromType: true,
        },
        {
          name: 'classified_songlist',
          text: '歌单',
          route: '/thunder/classified_songlist',
          isDot: false,
          hasFromType: true,
          isBlock: true,
          isForceBind: true,
        },
        {
          name: 'playcontrol',
          text: '',
          route: '',
          isDot: false,
          hasFromType: true,
          icon: 'https://qncweb.ktvsky.com/20251223/vadd/0824288fc34e6fc1e155565fd8565410.png',
        },
        {
          name: 'interact',
          text: '上屏',
          route: '/thunder/interact',
          isDot: false,
          hasFromType: true,
          isBlock: true,
          isForceBind: true,
          showNewHot: true,
        },
        {
          name: 'customer',
          text: '我的',
          route: '/thunder/customer',
          isDot: true,
          hasFromType: true,
        },
      ];
      // appFooterData.forEach((item, index) => {
      //   item.icon = FOOTRT_ICON_THEME[this.$theme].icon[index]
      //   item.activeIcon = FOOTRT_ICON_THEME[this.$theme].activeIcon[index]
      // })
      this.appFooterData = appFooterData;
    },
    saveOpenid(openid, unionid) {
      this.$store.commit('SAVE_OPENID', openid);
      this.$store.commit('SAVE_UNIONID', unionid);
    },
    async getOrderSystem() {
      const params = { Mac: this.Mac }
      // const params = { Mac: '11:22:33:44:55:66' }
      const res = await axiosAgent.post(`${order.api.guestScan}`, JSON.stringify(params))
      if (res.err == 0) {
        this.isSouyu = true
        this.isShowMenu = true
        this.$sendLog({
          event_type: 'show',
          event_name: '有手机点餐盒子数',
          event_data: {
            name: '搜娱点餐',
          },
        });
        sessionStorage.setItem('token', res.Token);
        this.$store.commit('SET_SYATEMS', res)
        if (!this.MT_ID) {
          this.isShowMenu = false
          return
        }
        const foodParams = {
          MT_ID: this.MT_ID,
          R_ID: this.R_ID,
          Flag: 4,
          page: 1,
          size: -1,
        }
        const result = await axiosAgent.post(`${order.api.frontFoodItemList}`, JSON.stringify(foodParams))
        if (get(result, 'data', []).length <= 0) {
          this.$sendLog({
            event_type: 'show',
            event_name: '无商品的盒子数-首页',
            event_data: {
              name: 'order_souyu',
            },
          });
        }
        this.$store.commit('SET_VOD_TYPE', 'souyu')
      } else {
        this.isShowMenu = false
      }
    },
    async refreshLiTongAccessToken(flag) {
      let access_token = ''
      const params = {}
      if (flag) {
        params.force = 1
      }
      const res = await chttp.get('vodc/diancan/token', { params })
      if (res && res.errcode == 200) {
        access_token = res.data.token
        sessionStorage.setItem('token', access_token);
      }
      return access_token
    },
    async getliTongvodStoreInfo() {
      const params = {
        // vodStoreId: '93537',
        vodStoreId: this.ktvid,
      }
      // 存在过期情况
      const res = await axiosAgent.post(`${order.api.liTongvodStoreInfo}`, params).catch(() => {})
      if (res && res.errcode == 0) {
        this.$store.commit('SET_LITONG_SYATEMS', res.result)
        this.$store.commit('SET_VOD_TYPE', 'litong')
        this.isLitong = true
        this.isShowMenu = true
        this.$sendLog({
          event_type: 'show',
          event_name: '有手机点餐盒子数',
          event_data: {
            name: '利通点餐',
          },
        });
      } else if (res && res.errcode == 14000102) {
        const token = await this.refreshLiTongAccessToken(true)
        if (token) {
        //   this.getliTongvodStoreInfo()
          this.isShowMenu = true
        } else {
          this.isShowMenu = false
        }
      }
    },
    closeAgree() {
      this.$store.commit('SAVE_AGREE_SHOW', false)
    },
  },
  computed: {
    ...mapState({
      is_vip: (state) => state.is_vip,
      is_bind: (state) => state.bind_status,
      keepAlive: (state) => state.keepAlive,
      isMinProgram: (state) => state.isMinProgram,
      show_barrage: (state) => state.show_barrage,
      giftShow: (state) => state.gift.giftShow,
      showPlaycontrol: (state) => state.showPlaycontrol,
      fansModalVipShow: (state) => state.fansModalVipShow,
      headimg: (state) => state.user_img,
      username: (state) => state.user_name,
      songInfo: (state) => state.adopt.songInfo,
      showVipPackagesToast: (state) => state.vip.showVipPackagesToast,
      unionid: (state) => state.unionid,
      openid: (state) => state.openid,
      showHomeToast: (state) => state.showHomeToast,
      bless_path: (state) => state.bless_path,
      Mac: (state) => state.Mac,
      ktvid: (state) => state.ktvid,
      R_ID: (state) => state.order.R_ID,
      MT_ID: (state) => state.order.MT_ID,
      routeTrack: (state) => state.statistics.routeTrack,
      hasFreeVipM: (state) => state.hasFreeVipM,
      isFreeVipM: (state) => state.isFreeVipM,
      isAgreeShow: (state) => state.isAgreeShow,
      isLeikeLinux: (state) => state.isLeikeLinux,
      isShowScode: (state) => state.isShowScode,
      isShowGiftBox: (state) => state.isShowGiftBox,
      $theme: (state) => state.$theme,
      isSupportInteract: (state) => state.isSupportInteract,
      showOpenToast: (state) => state.showOpenToast,
      showPhotoToast: (state) => state.showPhotoToast,
      isShowPayToast: (state) => state.isShowPayToast,
      isShowVoiceSearch: (state) => state.isShowVoiceSearch,
    }),
    showAppFooter() {
      // this.$route.meta.level === 1 1级页面显示底部导航栏
      // this.$route.query.isNewAnalytics 从首页进入保留底部导航栏（其他入口不显示）,新增好歌页面用于测试，好歌页面沿用排行榜页面
      return this.$route.meta.level === 1 || this.$route.query.isNewAnalytics === '1' || this.$route.query.topName === '好歌'
    },
    miniHide() { // 小程序中为了绕过ios支付审核不通过，需要在未绑定房台时隐藏支付入口
      return this.isMinProgram && !this.is_bind
    },
    computedShowToast() {
      // 公众号来源：gzhMsg
      let entrances = this.$route.query.fromType || '';
      // 判断是否是公众号来源，并且非首页
      return this.isSupportInteract && !this.miniHide && this.showHomeToast && this.showOpenToast && (entrances.includes('gzhMsg') && this.$route.path != '/thunder/home')
    },
  },
  watch: {
    is_bind(val) {
      if (val) {
        this.$store.dispatch('getGoldBaochang');
      }
    },
    is_vip(val) {
      if (val) {
        this.initAppFooterData()
      }
    },
    // 当全局主题发生变化（例如路由切换：首页 dark，其他页 light）时，刷新底部导航图标
    $theme(val) {
      if (val) {
        this.initAppFooterData();
      }
    }
  },
  components: {
    PlayControl,
    Barrage,
    NotVipToast,
    fansModal,
    Skeleton,
    VipPackagesToast,
    AppFooter,
    OrderSuccess,
    Agreement,
    SCodeBox,
    GiftBox,
    HomeToast,
    PhotoToast,
    PayToast,
    VoiceSearchDialog,
  },
};
</script>

<style lang="scss">
#app {
  min-height: 100%;
  overflow-x: hidden;
  background: #fff;
  // -webkit-overflow-scrolling: touch;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    &.router-link-exact-active {
      color: $active_font_color;
    }
  }
}
#LOG3 {
  display: none;
}
#AD {
  display: none;
}
</style>
